"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingDefault = exports.LoadingBg = exports.LoadingBgArray = exports.LoadingTypes = void 0;
var LoadingTypes = ['db', 'spinner'];
exports.LoadingTypes = LoadingTypes;
var LoadingBgArray = ['secondaryLight', 'white'];
exports.LoadingBgArray = LoadingBgArray;
var LoadingBg = {
  secondaryLight: 'rgba(250, 244, 239, 0.6)',
  white: 'rgba(255, 255, 255, 0.6)'
};
exports.LoadingBg = LoadingBg;
var LoadingDefault = {
  color: 'gray800',
  fontSize: 32,
  type: 'db',
  text: 'Loading...',
  full: true,
  bg: 'secondaryLight'
};
exports.LoadingDefault = LoadingDefault;